import React from "react";

export default function AiaBillingIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="1"
        y="1"
        width="12"
        height="12"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.2"
        fill="none"
      />
      <line x1="1" y1="4.5" x2="13" y2="4.5" stroke="currentColor" strokeWidth="1" />
      <line x1="5" y1="4.5" x2="5" y2="13" stroke="currentColor" strokeWidth="1" />
      <line x1="9" y1="4.5" x2="9" y2="13" stroke="currentColor" strokeWidth="1" />
    </svg>
  );
}
